
const AccessTokenTypes =  {
  JWT: 0,
}

export const AccessTokenTypeDisplayName = (type) => {
  switch (type) {
    case AccessTokenTypes.JWT:
      return "JWT"
    default:
      return null
  }
}

export default AccessTokenTypes